"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var markdown_to_jsx_1 = __importDefault(require("markdown-to-jsx"));
var TooltipContent_1 = __importDefault(require("atomicComponents/molecules/Tooltips/TooltipContent"));
var TooltipTemplate = function (_a) {
    var title = _a.title, description = _a.description, list = _a.list;
    return ((0, jsx_runtime_1.jsx)(TooltipContent_1.default, { title: (0, jsx_runtime_1.jsx)(markdown_to_jsx_1.default, { children: description !== null && description !== void 0 ? description : "**".concat(title, "** refers to either:") }), description: list && ((0, jsx_runtime_1.jsx)("ul", { children: list.map(function (item) { return (0, jsx_runtime_1.jsx)("li", { children: item }, item); }) })) }));
};
exports.default = TooltipTemplate;
